export enum UNAuthorizationOptions {
    // tslint:disable-next-line:no-bitwise
    badge = 1 << 0,
    // tslint:disable-next-line:no-bitwise
    sound = 1 << 1,
    // tslint:disable-next-line:no-bitwise
    alert = 1 << 2,
    // tslint:disable-next-line:no-bitwise
    carPlay = 1 << 3,
    // tslint:disable-next-line:no-bitwise
    criticalAlert = 1 << 4,
    // tslint:disable-next-line:no-bitwise
    providesAppNotificationSettings = 1 << 5,
    // tslint:disable-next-line:no-bitwise
    provisional = 1 << 6,
    // tslint:disable-next-line:no-bitwise
    announcement = 1 << 7,
}
